import clsx from 'clsx';
import { Check, X } from 'lucide-react';
import type { Draft, TrueFalseQ } from '../types';
import styles from '../QuizView.module.css';

type Props = {
  question: TrueFalseQ;
  draft: Extract<Draft, { format: 'true_false' }>;
  onChange: (d: Extract<Draft, { format: 'true_false' }>) => void;
  disabled: boolean;
  showFeedback: boolean;
};

const choices: Array<{ value: boolean; label: string }> = [
  { value: true, label: 'Verdadero' },
  { value: false, label: 'Falso' }
];

export function TrueFalse({ question, draft, onChange, disabled, showFeedback }: Props) {
  const expected =
    typeof question.correct_answer === 'boolean'
      ? question.correct_answer
      : Boolean(question.correct_answer);

  return (
    <div className={styles.options}>
      {choices.map((c, idx) => {
        const isPicked = draft.value === c.value;
        const isAnswer = c.value === expected;
        return (
          <button
            key={String(c.value)}
            type="button"
            onClick={() => onChange({ format: 'true_false', value: c.value })}
            className={clsx(
              styles.opt,
              showFeedback && isAnswer && styles.optCorrect,
              showFeedback && isPicked && !isAnswer && styles.optWrong,
              isPicked && !showFeedback && styles.optPicked
            )}
            aria-pressed={isPicked}
            disabled={disabled}
          >
            <span className={styles.optLetter}>{String.fromCharCode(65 + idx)}</span>
            <span className={styles.optText}>{c.label}</span>
            {showFeedback && isAnswer && <Check size={18} className={styles.optIcon} />}
            {showFeedback && isPicked && !isAnswer && <X size={18} className={styles.optIcon} />}
          </button>
        );
      })}
    </div>
  );
}
